import { Component, input } from '@angular/core';
import { SummaryCardAction, SummaryCardComponent } from '@next/core-lib/components';
import { NgTemplateOutlet, NgClass } from '@angular/common';

export type TextSize = 'default' | 'medium' | 'large';

@Component({
    selector: 'app-empty-widget',
    template: `
    @if (title()) {
      <agr-summary-card [title]="title()!" style="min-width: 380px" [actions]="actions()!">
        <ng-container *ngTemplateOutlet="body"></ng-container>
      </agr-summary-card>
    } @else {
      <ng-container *ngTemplateOutlet="body"></ng-container>
    }

    <ng-template #body>
      <div
        class="notification-empty flex--row flex--align-end flex--justify-center"
        [style.background-image]="linearGradient + ', ' + 'url(' + backgroundImage + ')'"
      >
        <p class="textBox" [ngClass]="[textSizeClass]" [innerHTML]="text()"></p>
      </div>
    </ng-template>
  `,
    styles: [
        `
      .notification-empty {
        height: 300px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-position: center;
        background-size: auto;

        .textBox {
          height: 100%;
          text-align: center;
          align-content: center;
        }

        & __content {


          .text--h2 {
            margin-top: 0;
            margin-bottom: $ spacing-xs-half;
          }

          p {
            margin-top: 0;
            margin-bottom: $ spacing-xs-half;
          }
        }

        & __action {
          margin: 0 16px;

          @include respond('lt-sm') {
            margin: 0 0 8px 0;
          }
        }

        @include respond('lt-sm') {
          & __content {
            height: 200px;
          }

          & __actions {
            flex-direction: column;
          }
        }
      }
    `,
    ],
    imports: [
        SummaryCardComponent,
        NgTemplateOutlet,
        NgClass,
    ],
})
export class EmptyWidgetComponent {
  readonly title = input<string>();
  readonly text = input<string>();
  readonly textSize = input<TextSize>('default');

  readonly actions = input<SummaryCardAction[] | null>(null);

  protected readonly linearGradient = 'linear-gradient(to bottom, rgba(255,255,255,0.00) 0%, rgba(255,255,255,1) 89%)';
  protected readonly backgroundImage = '../../../../assets/images/no-items-2.png';

  constructor() {}

  protected get textSizeClass(): string {
    switch (this.textSize()) {
      case 'large':
        return 'text--h2';
      case 'medium':
        return 'text--h3';
      case 'default':
      default:
        return 'text--body';
    }
  }
}
